import React from 'react';
import AlgoliaSearchBox from '../../../../../components/AlgoliaSearchBox';
import { EXPLORE } from '../../../../../utils/constants/SearchAnalyticsConstants';

const createReactClass = require('create-react-class');

const FullscreenBreadcrumbBar = createReactClass({
  render() {
    const bullet = <span>&nbsp; &#8226; &nbsp;</span>;
    const breadcrumbItems = this.props.items.map(function(item, i) {
      if (item.link && item.link != null) {
        let { link } = item;
        if (typeof window !== 'undefined') {
          link = window.checkLinkAndAppendLanguage(link);
        }
        return (
          <li className={item.class} key={`breadcrumb-${item.label}`}>
            {i > 0 && bullet}
            <a href={link}>{item.label}</a>
          </li>
        );
      }
      return (
        <li className={item.class} key={`breadcrumb-${item.label}`}>
          {i > 0 && bullet}
          {item.label}
        </li>
      );
    });
    return (
      <div id="breadcrumb-bar">
        <ul id="breadcrumb-list" className={this.props.className}>{breadcrumbItems}</ul>
        {this.props.showSearch &&
          <AlgoliaSearchBox
            onMapPage={this.props.onMapPage}
            numResults={this.props.isMobileWidth ? 8 : 10}
            currentUser={this.props.context.currentUser}
            mobileBrowser={this.props.context.mobileBrowser}
            languageRegionCode={this.props.context.languageRegionCode}
            useNewSearchExperience
            typeSubset={this.props.typeSubsets}
            page={EXPLORE}
          />
        }
      </div>
    );
  }
});

export { FullscreenBreadcrumbBar };
